import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/** Structured breadcrumb. items: [{label, to}] (last item = current, no link). */
export default function Breadcrumb({ items = [] }) {
  return (
    <nav aria-label="Fil d'ariane" className="text-sm" data-testid="breadcrumb">
      <ol className="flex flex-wrap items-center gap-1.5 text-slate-500">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {item.to && !last ? (
                <Link to={item.to} className="transition-colors hover:text-brand-red">
                  {item.label}
                </Link>
              ) : (
                <span className={last ? "font-medium text-brand-blue" : ""}>{item.label}</span>
              )}
              {!last && <ChevronRight className="h-3.5 w-3.5 text-slate-300" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
